import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/lib/b2b-services/guards/auth.guard';

const routes: Routes = [
  /* {
     path: '',
     loadChildren: () =>
       import('./pages/home/home.module').then((m) => m.HomeModule),
     canActivate: [AuthGuard],
   },*/
  /*{
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },*/
  {
    path: '',
    loadChildren: () => import('@b2b/home-lib').then((m) => m.HomeLibModule),
  },
  {
    path: 'tour-operators-registration',
    loadComponent: () =>
      import(
        '@app/lib/b2b-components/b2b-forms/travel-operators-registration-form/travel-operators-registration-form.component'
      ).then((c) => c.TravelOperatorsRegistrationFormComponent),
  },
  {
    path: 'auth',
    loadChildren: () => import('@b2b/auth-lib').then((m) => m.AuthModule),
  },
  {
    path: 'app',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'forbidden-access',
    loadComponent: () =>
      import('./pages/forbidden-access/forbidden-access.component'),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/page-not-found/page-not-found.component'),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
